import React, { useContext } from 'react';
import { style } from 'typestyle';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import * as styles from './modal.styles';
import PrimaryButton from '../../../core/components/buttons/primary-button.component';
import Column from '../../../core/components/column/column.component';
import { MainAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';
import { IsMobileContext } from '../../../core/context/is-mobile';

interface Props {
  readonly showModal: boolean;
  readonly handleClose: () => void;
  readonly handleAccept: () => void;
}

const RegisterAdminModal = ({ showModal, handleClose, handleAccept }: Props): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();
  return (
    <Modal ariaHideApp={false} isOpen={showModal} onRequestClose={handleClose} style={styles.modalStyle(isMobile)}>
      <Column>
        <span className={style(styles.bodyText)}>{t('register-administrator-request')}</span>
        <Row itemSpacing={12} mainAxisAlignment={MainAxisAlignment.Stretch}>
          <div className={style(styles.button)}>
            <PrimaryButton
              fullWidth
              onClick={(): void => {
                handleAccept();
              }}
            >
              {t('register')}
            </PrimaryButton>
          </div>
          <div className={style(styles.button)}>
            <PrimaryButton fullWidth onClick={handleClose}>
              {t('cancel')}
            </PrimaryButton>
          </div>
        </Row>
      </Column>
    </Modal>
  );
};

export default RegisterAdminModal;
